import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FileService } from 'src/app/services/file/file.service';
import Konva from 'konva';
import { MapService } from 'src/app/services/map/map.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { GalleryImagesStoreService } from 'src/app/stores/gallery-images-store/gallery-images-store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data/data.service';
import { GenericTypeService } from 'src/app/services/generic-type/generic-type.service';
import { GenericTypeStoreService } from 'src/app/stores/generic-types-store/generic-type-store.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { LocationComponentService } from 'src/app/services/locationComponent/location-component.service';
import { dataURLtoFile } from 'src/app/helpers/file.helper';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnnotationService } from 'src/app/services/annotation/annotation.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LocationUIService } from 'src/app/services/location-ui/location-ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnotationStoreService } from 'src/app/stores/annotation-store/annotation-store.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { hexToRgb } from 'src/app/components/openlayer/openlayer.component';
@Component({
  selector: 'app-gallery2',
  templateUrl: './gallery2.component.html',
  styleUrls: ['./gallery2.component.sass'],
  animations: [
    trigger('annotationForm', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('.5s ease-out', style({ height: '330px', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '330px', opacity: 1 }),
        animate('.5s ease-in', style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
})
export class Gallery2Component implements OnInit, OnDestroy {
  currentSlide: number = 0;
  images: any[];
  currLoc;
  modalRef: BsModalRef;
  isShowCarousel = false;
  isZoomIn = false;
  isZoomOut = false;
  prevZoomCoor = null;
  videoUrl = '';
  isVideo = false;
  annotationList;
  selectedDraw = null;
  submitted: boolean;

  @ViewChild('carouselModal') carouselModal: TemplateRef<any>;
  @ViewChild('konva') konva: TemplateRef<any>;
  @ViewChild('konva2') konva2: TemplateRef<any>;
  @ViewChild('annotationFormView') annotationFormView: TemplateRef<any>;
  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;

  stage: Konva.Stage;
  baseLayer: Konva.Layer;
  topLayer: Konva.Layer;
  transformer: Konva.Transformer;
  baseImage: Konva.Image;
  _isEditingTextNodeObj: { [konvaStg: string]: Konva.Text } = {};

  annotationForm: FormGroup;
  isAnnotationFormOn = false;
  isAnnotationFormOnUpdate = false;
  konvaScreenshot;
  severityList: any;
  selectedSeverityColor: string;
  defectTypes: any;
  locationComponentList: any;
  settimeout: NodeJS.Timeout;
  initImageLoaded = false;

  get isEditingTextNodeObj() {
    return this._isEditingTextNodeObj[this.stageName];
  }
  set isEditingTextNodeObj(obj: Konva.Text) {
    this._isEditingTextNodeObj[this.stageName] = obj;
  }

  _isEditingTextNodeTextAreaObj: { [konvaStg: string]: HTMLElement } = {};
  get isEditingTextNodeTextAreaObj() {
    return this._isEditingTextNodeTextAreaObj[this.stageName];
  }
  set isEditingTextNodeTextAreaObj(obj: HTMLElement) {
    this._isEditingTextNodeTextAreaObj[this.stageName] = obj;
  }

  textElements: Konva.Text[] = [];
  rectElements: Konva.Rect[] = [];
  circleElements: Konva.Circle[] = [];

  activeTool = '';

  // stageWidth = 650;
  // stageHeight = 380;
  // expand: 638px ; else 286
  stageWidth = 638;
  stageHeight = this.stageWidth * 0.6;
  isLoadingImage: boolean;

  widthScale = 0.7;
  widthRatio = (window.innerWidth * this.widthScale) / this.stageWidth;

  stageName: string;

  get konvaContainer() {
    return this.stageName === 'konva-stage'
      ? '.konva-container'
      : '.konva-container-2';
  }

  unsubber: Subject<boolean> = new Subject<boolean>();

  constructor(
    private fileService: FileService,
    private mapService: MapService,
    private modalService: BsModalService,
    private locationStore: LocationStoreService,
    private galleryImagesStore: GalleryImagesStoreService,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private genericTypeService: GenericTypeService,
    private genericTypeStore: GenericTypeStoreService,
    private locationComponentService: LocationComponentService,
    private spinner: NgxSpinnerService,
    private annotationService: AnnotationService,
    private _t: TranslateService,
    private toastr: ToastrService,
    private locationUiService: LocationUIService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private annotationStore: AnnotationStoreService
  ) {}

  ngOnInit(): void {
    if (!this.mapService.isGalleryImages$.getValue()) {
      this.mapService.toggleGalleryImages(true);
    }
    this.locationStore.currLocation$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (res.id) {
          this.currLoc = res;
          this.annotationForm = this.formBuilder.group({
            id: '',
            name: ['', Validators.required],
            description: ['', Validators.required],
            location: [this.currLoc.id, Validators.required],
            location_component: ['', Validators.required],
            annotation_type: ['', Validators.required],
            severity_type: ['', Validators.required],
            area: [{ value: '', disabled: true }, Validators.required],
            area_size: [0, Validators.required],
            gallery_image: ['', Validators.required],
            area_thumbnail: '',
            area_centroid: '',
          });

          // listen to severity_type input
          this.annotationForm
            .get('severity_type')
            .valueChanges.subscribe((val) => {
              // get color
              const _severities = this.severityList.filter((s) => s.id === val);
              if (_severities.length > 0) {
                const severityColor = _severities[0].description.trim();
                this.selectedSeverityColor = severityColor;
                // change drawing color
                this.changeDrawColor(this.selectedSeverityColor);
              }
            });
          this.galleryImagesStore.galleryImages$
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              if (res) {
                this.images = res;
                this.initImageLoaded = true;
                setTimeout(() => {
                  this.initKonva();
                });
                this.galleryImagesStore.galleryImagesCurrentIdx$
                  .pipe(takeUntil(this.unsubber.asObservable()))
                  .subscribe((index) => {
                    this.currentSlide = index;
                    if (this.images)
                      this.viewPort?.scrollToIndex(index, 'smooth');
                    setTimeout(() => {
                      this.initKonva();
                    });
                  });
                this.activatedRoute.paramMap.subscribe((paramMap) => {
                  if (
                    this.images.length > 0 &&
                    paramMap.get('imageId') &&
                    (paramMap.get('openModal') || paramMap.get('editAnnot')) &&
                    paramMap.get('drawing')
                  ) {
                    this.spinner.show();
                    // find image index
                    const i = this.images.findIndex(
                      (j) => j.id === paramMap.get('imageId')
                    );

                    setTimeout(() => {
                      // select the image
                      this.onClickThumbnail(i);

                      if (paramMap.get('openModal')) {
                        // open modal
                        this.showCarousel();

                        setTimeout(() => {
                          if (paramMap.get('drawing')) {
                            // show only the drawing
                            const drawing = JSON.parse(paramMap.get('drawing'));
                            let currentDrawOnly = JSON.stringify({
                              konva_annotations: {
                                attrs: {},
                                children: [...drawing],
                                className: 'Layer',
                              },
                            });

                            this.loadStringifiedJsonKonvaAnnotation(
                              currentDrawOnly
                            );
                          }
                          this.spinner.hide();
                        }, 2000);
                      }

                      if (paramMap.get('editAnnot')) {
                        setTimeout(() => {
                          if (paramMap.get('drawing')) {
                            // show only the drawing
                            const drawing = JSON.parse(paramMap.get('drawing'));
                            let currentDrawOnly = JSON.stringify({
                              konva_annotations: {
                                attrs: {},
                                children: [...drawing],
                                className: 'Layer',
                              },
                            });
                            this.loadStringifiedJsonKonvaAnnotation(
                              currentDrawOnly
                            );

                            const clickedAnnot = this.annotationList.filter(
                              (a) => {
                                if (
                                  paramMap.get('drawing') === a.area &&
                                  a.gallery_image === paramMap.get('imageId')
                                ) {
                                  return a;
                                }
                              }
                            );
                            if (clickedAnnot.length > 0) {
                              const a = clickedAnnot[0];
                              this.isAnnotationFormOnUpdate = true;
                              this.annotationForm.patchValue({
                                id: a.id,
                                name: a.name,
                                description: a.description,
                                location: a.location,
                                location_component: a.location_component.id
                                  ? a.location_component.id
                                  : a.location_component,
                                annotation_type: a.annotation_type.id
                                  ? a.annotation_type.id
                                  : a.annotation_type,
                                severity_type: a.severity_type.id
                                  ? a.severity_type.id
                                  : a.severity_type,
                                area: a.area,
                                area_size: a.area_size,
                                gallery_image: a.gallery_image,
                              });
                              this.konvaScreenshot = a.area_thumbnail;
                            }
                            this.spinner.hide();
                          }
                        }, 2000);
                      }
                    }, 2000);
                  }
                });
              }
            });
          this.getLocationComponentList(res);
          this.locationComponentList = this.dataService.locationComponentList;
          this.genericTypeService
            .findAll()
            .pipe(takeUntil(this.unsubber.asObservable()))
            .subscribe((res) => {
              this.genericTypeStore.setGenericTypes = res.data;
              this.defectTypes = this.genericTypeStore.defectTypeList;

              if (this.currLoc?.generic_type_template?.severity_set) {
                this.severityList =
                  this.currLoc.generic_type_template.severity_set.map((i) => {
                    return this.genericTypeStore.severityList.find(
                      (s) => s.id === i
                    );
                  });
              } else {
                this.severityList = this.genericTypeStore.severityList;
              }

              if (this.currLoc?.generic_type_template?.annotation_set) {
                this.defectTypes =
                  this.currLoc.generic_type_template.annotation_set.map((i) => {
                    return this.genericTypeStore.defectTypeList.find(
                      (s) => s.id === i
                    );
                  });
              } else {
                this.defectTypes = this.genericTypeStore.defectTypeList;
              }
            });
        }
      });
    this.modalService.onHide
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((reason: string | any) => {
        this.isAnnotationFormOn = false;
        setTimeout(() => {
          this.initKonva();
        });
      });
    this.modalService.onShown
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe(() => {
        this.initKonva(
          'konva-stage2',
          window.innerWidth * this.widthScale,
          window.innerHeight * this.widthScale
        );
      });

    this.annotationStore.annotationsGallery$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => (this.annotationList = res));
  }

  ngOnDestroy() {
    this.mapService.toggleGalleryImages(false);
    this.unsubber.next();
    this.unsubber.unsubscribe();
  }

  resetKonva(konvaStageId?) {
    this.resetAnnotationForm();
    if (konvaStageId) {
      this.initKonva(
        konvaStageId,
        window.innerWidth * this.widthScale,
        window.innerHeight * this.widthScale
      );
    } else {
      this.initKonva();
    }
  }

  getLocationComponentList(currLoc): void {
    this.locationComponentService
      .findAll([
        { key: 'filtered[0][key]', val: 'location' },
        { key: 'filtered[0][val]', val: currLoc.id },
      ])
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.locationComponentList = res.data;
        this.dataService.locationComponentList = res.data;
      });
  }

  initKonva(
    container = 'konva-stage',
    width = this.stageWidth,
    height = this.stageHeight
  ) {
    if (this.images[this.currentSlide]?.file_type === 'videos') {
      this.initMatVideo();
      return;
    } else {
      this.videoUrl = '';
      this.isVideo = false;
      setTimeout(() => {
        if (this.images.length === 0) return;
        this.stageName = container;
        this.stage = new Konva.Stage({
          container,
          width,
          height,
          fill: '#BEBEBE',
          draggable: true,
        });

        this.topLayer = new Konva.Layer();
        this.baseLayer = new Konva.Layer();

        this.stage.add(this.baseLayer);
        this.stage.add(this.topLayer);

        this.transformer = new Konva.Transformer({ keepRatio: false });
        this.topLayer.add(this.transformer);
        this.topLayer.draw();

        this.isLoadingImage = true;
        const that = this;
        var imageObj = new Image();
        imageObj.onload = function () {
          that.baseImage = new Konva.Image({
            x: 0,
            y: 0,
            width: that.stageWidth,
            height: that.stageHeight,
            image: imageObj,
          });
          that.baseLayer.destroyChildren();
          that.baseLayer.add(that.baseImage);
          that.baseLayer.draw();
          that.isLoadingImage = false;
          that.loadSavedData(container);
          that.initEvents();
        };
        imageObj.crossOrigin = 'Anonymous';
        let lg_img = this.images[this.currentSlide]?.url_large;
        if (lg_img === null) lg_img = this.images[this.currentSlide]?.url;
        // imageObj.src = this.images ? (container === 'konva-stage' ? 'https://proxy.aerodyne.dev/'+lg_img : 'https://proxy.aerodyne.dev/'+this.images[this.currentSlide]?.url) : '';
        imageObj.src = this.images
          ? container === 'konva-stage'
            ? lg_img
            : this.images[this.currentSlide]?.url
          : '';

        // //center map follow image centroid
        // const metadata = JSON.parse(this.images[this.currentSlide].metadata_stringified)
        // if (this.navigationService.history.length > 1) {
        // 	this.mapService.centerTo([metadata.GpsLongitude.substring(1), metadata.GpsLatitude.substring(1)])
        // } else {
        // 	this.mapService.map.once('moveend', () => {
        // 		this.mapService.centerTo([metadata.GpsLongitude.substring(1), metadata.GpsLatitude.substring(1)])
        // 	})
        // }
        this.annotationForm.patchValue({
          gallery_image: this.images[this.currentSlide].id,
        });
      });
    }
  }

  initMatVideo() {
    this.videoUrl = this.images[this.currentSlide]?.url;

    setTimeout(() => {
      this.isVideo = true;
    }, 100);
  }

  loadSavedData(konva_stage_id?) {
    let combineDraw = {
      konva_annotations: {
        attrs: {},
        children: [],
        className: 'Layer',
      },
    };
    for (let annot of this.annotationList) {
      if (annot.gallery_image !== this.images[this.currentSlide]?.id) {
        continue;
      }
      let draw = JSON.parse(annot.area);
      combineDraw.konva_annotations.children =
        combineDraw.konva_annotations.children.concat(draw);
    }
    // const konva_annotations = this.images[this.currentSlide]?.konva_annotations
    const konva_annotations =
      this.annotationList.length > 0 ? JSON.stringify(combineDraw) : undefined;
    if (konva_stage_id === 'konva-stage2') {
      this.stage.scale({ x: this.widthRatio, y: this.widthRatio });
    }
    if (!konva_annotations) {
      this.topLayer.destroy();

      var nodes00 = this.topLayer.getChildren(function (node) {
        return (
          node.getClassName() === 'Rect' ||
          node.getClassName() === 'Circle' ||
          node.getClassName() === 'Text'
        );
      });

      this.topLayer = new Konva.Layer();
      this.stage.add(this.topLayer);
      this.stage.draw();
      this.topLayer.draw();

      this.transformer = new Konva.Transformer({ keepRatio: false });
      this.topLayer.add(this.transformer);
      this.topLayer.draw();
    } else {
      this.loadStringifiedJsonKonvaAnnotation(konva_annotations);
    }
  }

  loadStringifiedJsonKonvaAnnotation(konva_annotations) {
    const konvaAnnotation = JSON.parse(konva_annotations);
    const loadedJSON = konvaAnnotation.konva_annotations;
    // let scale = this.stageWidth/konvaAnnotation.stageWidth
    // if (konvaAnnotation.stageWidth > ) {}

    this.topLayer.destroy();

    this.topLayer = Konva.Node.create(loadedJSON);
    this.topLayer.opacity(0);

    this.stage.add(this.topLayer);

    this.stage.draw();
    this.topLayer.draw();

    var nodes = this.topLayer.getChildren(function (node) {
      return (
        node.getClassName() === 'Rect' ||
        node.getClassName() === 'Circle' ||
        node.getClassName() === 'Text'
      );
    });

    var transformers = this.topLayer.getChildren(function (node) {
      return node.getClassName() === 'Transformer';
    });

    let transformersLen = transformers.length;
    while (transformersLen--) {
      transformers[transformersLen].destroy();
    }

    let nodesLen = nodes.length;
    while (nodesLen--) {
      nodes[nodesLen].visible(true);
      nodes[nodesLen].on('dragend', () => {
        this.screenshotKonva();
        this.saveStage();
      });
      nodes[nodesLen].on('transformend', () => {
        this.screenshotKonva();
        this.saveStage();
      });
    }

    this.transformer = new Konva.Transformer({ keepRatio: false });

    if (nodes[0]) {
      // this.transformer.nodes([nodes[0]]); // show transform box on init
    }
    this.topLayer.add(this.transformer);
    this.topLayer.draw();

    const fadeInTopLayer = new Konva.Tween({
      opacity: 1,
      node: this.topLayer,
      easing: Konva.Easings.EaseOut,
      duration: 0,
    });

    setTimeout(() => {
      fadeInTopLayer.play();
    }, 100);
  }

  initEvents() {
    this.stage.off('click tap');
    // clicks should select/deselect shapes
    this.stage.on('click tap', (e) => {
      if (e.target == this.stage || e.target == this.baseImage) {
        this.selectedDraw = null;
        const btnElems = document.getElementsByClassName('konva-clear-btn');
        for (var i = 0; i < btnElems.length; i++) {
          btnElems.item(i).innerHTML = 'Clear All';
        }
        if (!this.isEditingTextNodeObj) {
          if (this.transformer.nodes()) {
            const nodes = this.transformer.nodes().slice();

            if (this.transformer.nodes().length > 0) {
              this.transformer.nodes([]);
              this.topLayer.draw();
            } else {
              this.createNewElement();
            }
          } else {
            this.createNewElement();
          }
        } else {
          this.removeTempTextArea();
        }
      } else {
        const clickedAnnot = this.annotationList.filter((a) => {
          let clickedArea = JSON.parse(e.target.toJSON());
          if (
            JSON.stringify(clickedArea) ==
              JSON.stringify(JSON.parse(a.area)[0]) &&
            a.gallery_image === this.images[this.currentSlide].id
          ) {
            return a;
          }
        });
        if (clickedAnnot.length > 0) {
          const a = clickedAnnot[0];
          this.isAnnotationFormOnUpdate = true;
          this.annotationForm.patchValue({
            id: a.id,
            name: a.name,
            description: a.description,
            location: a.location,
            location_component: a.location_component.id
              ? a.location_component.id
              : a.location_component,
            annotation_type: a.annotation_type.id
              ? a.annotation_type.id
              : a.annotation_type,
            severity_type: a.severity_type.id
              ? a.severity_type.id
              : a.severity_type,
            area: a.area,
            area_size: a.area_size,
            gallery_image: a.gallery_image,
          });
          this.konvaScreenshot = a.area_thumbnail;
        }

        this.selectedDraw = e.target;
        const btnElems = document.getElementsByClassName('konva-clear-btn');
        for (var i = 0; i < btnElems.length; i++) {
          btnElems.item(i).innerHTML = 'Clear Selected';
        }
        this.transformer.nodes([e.target]);
        this.topLayer.draw();
      }
    });

    const scaleBy = 1.01;
    this.stage.on('wheel', (e) => {
      e.evt.preventDefault();
      var oldScale = this.stage.scaleX();

      var pointer = this.stage.getPointerPosition();

      var mousePointTo = {
        x: (pointer.x - this.stage.x()) / oldScale,
        y: (pointer.y - this.stage.y()) / oldScale,
      };

      var newScale = e.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;

      this.stage.scale({ x: newScale, y: newScale });

      var newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale,
      };
      this.stage.position(newPos);
      this.stage.batchDraw();
    });
  }

  createNewElement() {
    if (this.activeTool == null) {
      return;
    }
    switch (this.activeTool) {
      case 'text':
        this.createNewText();
        break;

      case 'rectangle':
        this.createNewRect();
        break;

      case 'circle':
        this.createNewCircle();
        break;

      default:
        break;
    }
  }

  changeDrawColor(hexColor) {
    let rgbaColor: any = hexToRgb(hexColor);
    let layer = this.topLayer.toJSON();

    rgbaColor = `rgba(${rgbaColor[0]}, ${rgbaColor[1]}, ${rgbaColor[2]}, ${
      layer.includes('fill') ? '0.3' : '1'
    })`;
    layer = layer.replace(/rgba\((.*?)\)/i, rgbaColor);

    let currentDrawOnly = JSON.stringify({
      konva_annotations: {
        attrs: {},
        children: [...JSON.parse(layer).children],
        className: 'Layer',
      },
    });
    this.annotationForm.patchValue({
      area: JSON.stringify(JSON.parse(layer).children),
    });
    this.loadStringifiedJsonKonvaAnnotation(currentDrawOnly);
  }

  removeTempTextArea() {
    var container = <HTMLElement>document.querySelector(this.konvaContainer);
    const childToRemove = this.isEditingTextNodeTextAreaObj;
    if (container.contains(childToRemove)) container.removeChild(childToRemove);
    else delete this.isEditingTextNodeTextAreaObj;

    this.isEditingTextNodeObj.text(
      (this.isEditingTextNodeTextAreaObj as HTMLInputElement).value
    );

    this.isEditingTextNodeObj.on('dragend', () => this.saveStage());
    this.isEditingTextNodeObj.on('transformend', () => this.saveStage());

    this.isEditingTextNodeObj.show();
    this.transformer.show();
    this.transformer.forceUpdate();
    this.topLayer.draw();
    this.isEditingTextNodeObj = null;
    this.isEditingTextNodeTextAreaObj = null;

    this.saveStage();
  }

  getRelativePointerPosition(node = this.stage) {
    var transform = node.getAbsoluteTransform().copy();
    // to detect relative position we need to invert transform
    transform.invert();

    // get pointer (say mouse or touch) position
    var pos = node.getStage().getPointerPosition();

    // now we can find relative point
    return transform.point(pos);
  }

  createNewText() {
    const prevTopLayer = this.topLayer.toJSON();
    const text = new Konva.Text({
      x: 200,
      y: 100,
      text: 'Double click to edit text.',
      fontSize: 18,
      fontFamily: 'HelveticaNeueLTStd-Roman',
      fill: 'white',
      width: 250,
      padding: 10,
      align: 'center',
      draggable: false,
      stroke: 'rgba(0, 0, 0, 0.7)',
      strokeWidth: 0.5,
    });

    this.topLayer.add(text);
    this.transformer.nodes([text]);
    this.transformer.keepRatio(true);
    this.topLayer.draw();
    this.clickPointerButton();

    this.textElements.push(text);

    text.on('dblclick', () => this.onTextDoubleClick(text));
    // text.on("click tap", () => this.onElementsClicked(text));
    // text.on("mouseenter", () => this.onElementsClicked(text));
    this.onElementsClicked(text);
    this.saveStage(text, prevTopLayer);
  }

  createNewRect() {
    const prevTopLayer = this.topLayer.toJSON();
    const rect = new Konva.Rect({
      x: this.getRelativePointerPosition().x - 25,
      y: this.getRelativePointerPosition().y - 25,
      width: 50,
      height: 50,
      name: 'rect',
      draggable: true,
      stroke: this.selectedSeverityColor || 'rgba(255, 0, 0, 1)',
      lineHeight: 18,
      strokeWidth: 3,
    });
    this.topLayer.add(rect);

    this.rectElements.push(rect);
    this.transformer.nodes([rect]);
    this.transformer.keepRatio(false);

    this.topLayer.draw();
    this.clickPointerButton();

    // rect.on("click tap", () => this.onElementsClicked(rect));
    // rect.on("dragend", () => this.saveStage());
    // rect.on("transformend", () => this.saveStage());
    this.saveStage(rect, prevTopLayer);
  }

  createNewCircle() {
    const prevTopLayer = this.topLayer.toJSON();
    const circle = new Konva.Circle({
      x: this.getRelativePointerPosition().x,
      y: this.getRelativePointerPosition().y,
      radius: 50,
      name: 'rect',
      draggable: true,
      stroke: this.selectedSeverityColor || 'rgba(255, 0, 0, 1)',
      strokeWidth: 3,
    });
    this.topLayer.add(circle);

    this.circleElements.push(circle);
    this.transformer.nodes([circle]);
    this.transformer.keepRatio(false);

    this.topLayer.draw();
    this.clickPointerButton();

    // circle.on("click tap", () => this.onElementsClicked(circle));
    // circle.on("dragend", () => this.saveStage());
    // circle.on("transformend", () => this.saveStage());
    this.saveStage(circle, prevTopLayer);
  }

  onTextDoubleClick(text: Konva.Text) {
    if (text.attrs?.text != 'Double click to edit text.') return;
    this.createTempTextArea(text);
  }

  createTempTextArea(textNode: Konva.Text) {
    const env = this;
    // hide text node and transformer:
    textNode.hide();
    this.transformer.hide();
    this.topLayer.draw();

    // create textarea over canvas with absolute position
    // first we need to find position for textarea
    // how to find it?

    // at first lets find position of text node relative to the stage:
    var textPosition = textNode.getAbsolutePosition();

    // then lets find position of stage container on the page:
    var stageBox = this.stage.container().getBoundingClientRect();

    // so position of textarea will be the sum of positions above:
    var areaPosition = {
      x: textPosition.x + 10 * this.stage.scale().x,
      y: textPosition.y + 10 * this.stage.scale().y,
    };

    // create textarea and style it
    var container = <HTMLElement>document.querySelector(this.konvaContainer);
    var textarea = document.createElement('textarea');
    container.appendChild(textarea);

    // apply many styles to match text on canvas as close as possible
    // remember that text rendering on canvas and on the textarea can be different
    // and sometimes it is hard to make it 100% the same. But we will try...
    // textarea.value = textNode.text();
    textarea.value = '';
    textarea.style.position = 'absolute';
    textarea.style.top = areaPosition.y + 'px';
    textarea.style.left = areaPosition.x + 'px';
    textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px';
    //textarea.style.height = textNode.height() - textNode.padding() * 2 + 5 + 'px';
    textarea.style.height = '200px';
    textarea.style.fontSize = textNode.fontSize() + 'px';
    textarea.style.border = 'none';
    textarea.style.padding = '0px';
    textarea.style.margin = '0px';
    textarea.style.overflow = 'hidden';
    textarea.style.background = 'none';
    textarea.style.outline = 'none';
    textarea.style.resize = 'none';
    textarea.style.lineHeight = '18px';
    textarea.style.fontFamily = textNode.fontFamily();
    textarea.style.transformOrigin = 'left top';
    textarea.style.textAlign = textNode.align();
    textarea.style.color = textNode.fill();
    let rotation = textNode.rotation();
    var transform = '';
    if (rotation) {
      transform += 'rotateZ(' + rotation + 'deg)';
    }

    var px = 0;
    // also we need to slightly move textarea on firefox
    // because it jumps a bit
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (isFirefox) {
      px += 2 + Math.round(textNode.fontSize() / 20);
    }
    transform += 'translateY(-' + px + 'px)';
    textarea.style.transform = transform;

    // reset height
    textarea.style.height = 'auto';
    // after browsers resized it we can set actual value
    textarea.style.height = textarea.scrollHeight + 3 + 'px';

    textarea.focus();

    textarea.addEventListener('keydown', function (e) {
      // hide on enter
      // but don't hide on shift + enter
      if (e.keyCode === 13 && !e.shiftKey) {
        textNode.text(textarea.value);
        env.removeTempTextArea();
      }
      // on esc do not set value back to node
      if (e.keyCode === 27) {
        env.removeTempTextArea();
      }
    });

    textNode.setAttr('draggable', true);
    this.topLayer.draw();
    this.clickPointerButton();

    this.isEditingTextNodeObj = textNode;
    this.isEditingTextNodeTextAreaObj = textarea;
  }

  onElementsClicked(elem) {
    this.transformer.nodes([elem]);
    this.topLayer.draw();
  }

  activateTool(tool = null) {
    this.activeTool = tool;
    if (!this.activeTool) {
      if (this.isEditingTextNodeObj) {
        this.removeTempTextArea();
      } else {
        this.transformer.nodes([]);
        this.topLayer.draw();
      }
    }
  }

  clickPointerButton(): void {
    const pointers = document.getElementsByClassName('icon-pointer');
    const btn = document.querySelectorAll(
      '.btn-group.btn-group-toggle > button'
    );
    for (var i = 0, element; (element = btn[i]); i++) {
      element.blur();
    }

    for (var i = 0; i < pointers.length; i++) {
      const parent = pointers.item(i).parentElement;
      parent.click();
    }
  }

  onClickClearBtn() {
    if (this.selectedDraw) {
      this.transformer.nodes([]);
      this.selectedDraw.destroy();
      this.selectedDraw = null;
    } else {
      this.topLayer.clear();
      this.topLayer.destroy();
    }
    const btnElems = document.getElementsByClassName('konva-clear-btn');
    for (var i = 0; i < btnElems.length; i++) {
      btnElems.item(i).innerHTML = 'Clear All';
    }
    this.resetAnnotationForm();

    this.saveStage();

    this.topLayer = new Konva.Layer();
    this.stage.add(this.topLayer);
    this.stage.draw();
    this.topLayer.draw();

    this.transformer = new Konva.Transformer({ keepRatio: false });
    this.topLayer.add(this.transformer);
    this.topLayer.draw();
  }

  saveStage(draw = null, prevTopLayer = null) {
    const annotation = this.topLayer.toJSON();
    const data = JSON.stringify({
      konva_annotations: annotation,
      stageWidth: this.stageWidth,
    });

    if (draw !== null) {
      const area = getDiffFromArray(
        JSON.parse(prevTopLayer).children,
        JSON.parse(annotation).children
      );
      let currentDrawOnly = JSON.stringify({
        konva_annotations: {
          attrs: {},
          children: [...area],
          className: 'Layer',
        },
      });
      this.loadStringifiedJsonKonvaAnnotation(currentDrawOnly);
      clearTimeout(this.settimeout);
      this.settimeout = setTimeout(() => {
        this.screenshotKonva();
        // this.loadStringifiedJsonKonvaAnnotation(
        // 	JSON.stringify({ konva_annotations: annotation })
        // );

        this.isAnnotationFormOn = true;
        this.annotationForm.patchValue({
          area: JSON.stringify(area),
          area_thumbnail: this.konvaScreenshot,
        });
      }, 200);
    } else {
      // this.fileService.updateKonva(this.images[this.currentSlide].id, {konva_annotations: data}).subscribe(res => {
      // 	this.images[this.currentSlide].konva_annotations = data
      // })
      this.annotationForm.patchValue({
        area: JSON.stringify(JSON.parse(annotation).children),
      });
    }
  }

  onNavCarousel(currentSlide: number) {
    this.currentSlide = currentSlide;
  }

  onClickThumbnail(slideIndex) {
    this.currentSlide = slideIndex;
    this.mapService.showSingleGalleryImagesMarker(this.currentSlide);
    this.recenter(this.currentSlide);

    this.viewPort.scrollToIndex(this.currentSlide, 'smooth');
  }

  onClickNav(to) {
    switch (to) {
      case 'next':
        if (this.currentSlide < this.images.length - 1) {
          this.currentSlide++;
        }
        break;
      case 'prev':
        if (this.currentSlide > 0) {
          this.currentSlide--;
        }
        break;
    }
    this.mapService.showSingleGalleryImagesMarker(this.currentSlide);
    this.recenter(this.currentSlide);

    this.viewPort.scrollToIndex(this.currentSlide, 'smooth');
  }

  recenter(index) {
    this.isVideo = false;
    const metadata = JSON.parse(this.images[index].metadata_stringified);
    if (metadata.GpsLongitude && metadata.GpsLatitude) {
      this.mapService.map.flyTo({
        center: [
          parseFloat(metadata.GpsLongitude),
          parseFloat(metadata.GpsLatitude),
        ],
        curve: 0,
      });
    }
    const konvaStage2 = document.getElementById('konva-stage2');
    if (konvaStage2) {
      this.initKonva(
        'konva-stage2',
        window.innerWidth * this.widthScale,
        window.innerHeight * this.widthScale
      );
    } else {
      this.initKonva();
    }
  }

  showCarousel(index = this.currentSlide) {
    if (!this.initImageLoaded) {
      return;
    }
    this.isShowCarousel = true;
    this.currentSlide = index;
    this.modalRef = this.modalService.show(this.konva2, {
      class: 'modal-lg gallery2',
    });
  }

  hideCarousel() {
    this.isShowCarousel = false;
    this.modalRef.hide();
  }

  toggleZoom(state = 'zoomin') {
    switch (state) {
      case 'zoomin':
        this.isZoomIn = !this.isZoomIn;
        this.isZoomOut = false;
        break;
      case 'zoomout':
        this.isZoomOut = !this.isZoomOut;
        this.isZoomIn = false;
        break;

      default:
        break;
    }
  }

  onSubmitForm(): void {
    this.submitted = true;
    if (this.annotationForm.valid) {
      const form = this.annotationForm.getRawValue();
      for (var propName in form) {
        if (
          form[propName] === null ||
          form[propName] === undefined ||
          form[propName] === ''
        ) {
          delete form[propName];
        }
      }
      let submitService = this.annotationService
        .createAnnotation(form)
        .pipe(takeUntil(this.unsubber.asObservable()));
      if (this.isAnnotationFormOnUpdate) {
        submitService = this.annotationService
          .update(form.id, form)
          .pipe(takeUntil(this.unsubber.asObservable()));
      }
      this.spinner.show();
      submitService.subscribe({
        next: async (createdAnnot) => {
          if (createdAnnot) {
            if (form.area_thumbnail) {
              const file = dataURLtoFile(
                form.area_thumbnail,
                `area_thumbnail_${
                  this.locationStore.currentLocation.id
                }_${Date.now()}`
              );

              //upload area_thumnbnail to s3
              const formData = new FormData();
              formData.append('annotation', file);
              formData.append(
                'location',
                this.locationStore.currentLocation.id
              );
              formData.append('annotation_id', createdAnnot.id);

              this.fileService
                .create(formData)
                .pipe(takeUntil(this.unsubber.asObservable()))
                .subscribe(async (createdFile) => {
                  this.mapService.threeDScreenshotBlob$.next(null);
                  await this.annotationService
                    .update(createdAnnot.id, {
                      area_thumbnail: createdFile[0].url,
                      annotation_file: createdFile[0].id,
                    })
                    .subscribe(
                      (res) => (this.annotationStore.appendAnnotation = res)
                    );
                  await this.locationUiService.refreshDefectCounts(
                    this.locationStore.currentLocation.id
                  );
                  this.toastr.success(
                    this._t.instant('Successfully save annotate'),
                    this._t.instant('Success')
                  );
                  this.resetKonva();

                  const annotation = this.topLayer.toJSON();
                  const data = JSON.stringify({
                    konva_annotations: annotation,
                    stageWidth: this.stageWidth,
                  });
                  this.fileService
                    .updateKonva(this.images[this.currentSlide].id, {
                      konva_annotations: data,
                    })
                    .subscribe((res) => {
                      this.images[this.currentSlide].konva_annotations = data;
                    });
                  this.resetAnnotationForm();

                  this.spinner.hide();
                });
            } else {
              this.annotationStore.appendAnnotation = createdAnnot;
              this.toastr.success(
                this._t.instant('Successfully save annotate'),
                this._t.instant('Success')
              );
              this.resetKonva();

              const annotation = this.topLayer.toJSON();
              const data = JSON.stringify({
                konva_annotations: annotation,
                stageWidth: this.stageWidth,
              });
              this.fileService
                .updateKonva(this.images[this.currentSlide].id, {
                  konva_annotations: data,
                })
                .subscribe((res) => {
                  this.images[this.currentSlide].konva_annotations = data;
                });
              this.resetAnnotationForm();

              this.spinner.hide();
            }
          }
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {},
          });
        },
        error: ({ error }) => {
          this.spinner.hide();
          const msg = error.message
            .reduce((results, u) => ((results += u + ', '), results), '')
            .slice(0, -2);
          this.toastr.error(msg, this._t.instant('Error'));
        },
      });
    }
  }

  resetAnnotationForm() {
    this.submitted = false;
    this.annotationForm.patchValue({
      name: '',
      description: '',
      location_component: '',
      annotation_type: '',
      severity_type: '',
      area: '',
      area_size: 0,
      gallery_image: '',
      area_thumbnail: '',
      area_centroid: '',
    });
    this.konvaScreenshot = '';
    this.isAnnotationFormOn = false;
    this.isAnnotationFormOnUpdate = false;
    this.selectedSeverityColor = null;
    setTimeout(() => {
      this.initKonva();
    });
  }

  screenshotKonva() {
    this.konvaScreenshot = this.stage.toDataURL({ mimeType: 'image/png' });
    this.annotationForm.patchValue({ area_thumbnail: this.konvaScreenshot });
  }
}

function comparer(otherArray) {
  return function (current) {
    return (
      otherArray.filter(function (other) {
        return JSON.stringify(current) === JSON.stringify(other);
      }).length == 0
    );
  };
}

function getDiffFromArray(arr1, arr2) {
  var onlyInA = arr1.filter(comparer(arr2));
  var onlyInB = arr2.filter(comparer(arr1));

  return onlyInA.concat(onlyInB);
}
